import React from 'react';
import './ProgramGrid.css';

function ProgramGrid({ onCtaClick }) {
  const gridCards = [
    {
      id: 1,
      titleNormal: 'Regular Coaching And',
      titleSerif: 'Clinical Touchpoints',
      desc: 'Structured Monthly Follow-Ups And Strategy Sessions To Keep You Accountable And Aligned.',
      variant: 'blue',
      icon: '/images/icons/landing-grid-card-icon-1.png'
    },
    {
      id: 2,
      titleNormal: 'In-Hospital',
      titleSerif: 'Advocacy',
      desc: "Should You Require Hospitalization, We Ensure You're Not Navigating Alone.",
      variant: 'dark',
      icon: '/images/icons/landing-grid-card-icon-2.png'
    },
    {
      id: 3,
      titleNormal: 'Annual Executive',
      titleSerif: 'Health Assessment',
      desc: 'A Full-Spectrum, Multidisciplinary Evaluation Covering Key Risk Domains And Baseline Performance.',
      variant: 'blue',
      icon: '/images/icons/landing-grid-card-icon-3.png'
    },
    {
      id: 4,
      titleNormal: 'Dedicated',
      titleSerif: 'Clinical Team',
      desc: 'Physicians, Naturopaths, Physiologists, And Health Strategists Collaborating Under One Roof.',
      variant: 'dark',
      icon: '/images/icons/landing-grid-card-icon-4.png'
    },
    {
      id: 5,
      titleNormal: 'Global Health',
      titleSerif: 'Support',
      desc: 'Medical Coordination Anywhere Life Or Work Takes You.',
      variant: 'blue',
      icon: '/images/icons/landing-grid-card-icon-5.png'
    }
  ];

  return (
    <section className="ttc-program-grid-wrapper py-5">
      <div className="container py-lg-4">
        <div className="row g-4 align-items-stretch">
          {/* Feature Cards 1 to 5 */}
          {gridCards.map((card) => (
            <div key={card.id} className="col-12 col-md-6 col-lg-4 d-flex">
              <div className={`ttc-program-card ttc-program-card-${card.variant} w-100`}>
                <div className="ttc-program-icon-box mb-4">
                  <img src={card.icon} alt="" className="img-fluid" />
                </div>
                <h3 className="ttc-program-card-title mb-3">
                  {card.titleNormal} <br />
                  <span className="ttc-program-title-serif">{card.titleSerif}</span>
                </h3>
                <p className="ttc-program-card-desc mb-0">{card.desc}</p>
              </div>
            </div>
          ))}

          {/* 6th Slot: Circular Rotating Get Started CTA */}
          <div className="col-12 col-md-6 col-lg-4 d-flex align-items-center justify-content-center">
            <button 
              type="button" 
              onClick={onCtaClick}
              className="ttc-program-cta-btn"
              aria-label="Get Started - Scroll to consultation form"
            >
              {/* Curved SVG Text Ring */}
              <svg className="ttc-program-rotating-text" viewBox="0 0 200 200">
                <path
                  id="circlePath"
                  d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0"
                  fill="none"
                />
                <text fill="#258bf5" fontSize="16" fontWeight="600" letterSpacing="4">
                  <textPath href="#circlePath" startOffset="0%">
                    Get Started • Get Started • Get Started •
                  </textPath>
                </text>
              </svg>

              {/* Inner Circle Arrow */}
              <div className="ttc-program-cta-center">
                <svg 
                  width="28" 
                  height="28" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2.5" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <line x1="7" y1="17" x2="17" y2="7"></line>
                  <polyline points="7 7 17 7 17 17"></polyline>
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProgramGrid;